import { render, staticRenderFns } from "./SessionTypeIcon.vue?vue&type=template&id=b808bede"
import script from "./SessionTypeIcon.vue?vue&type=script&lang=js"
export * from "./SessionTypeIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports